import { render, staticRenderFns } from "./AIOpenEndedAllGroups.vue?vue&type=template&id=1ec24f32&scoped=true&"
import script from "./AIOpenEndedAllGroups.vue?vue&type=script&lang=js&"
export * from "./AIOpenEndedAllGroups.vue?vue&type=script&lang=js&"
import style0 from "./AIOpenEndedAllGroups.vue?vue&type=style&index=0&id=1ec24f32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec24f32",
  null
  
)

export default component.exports